import styled from 'styled-components'
import { PlayheadWithoutContext } from '../../../playhead'

export const Playhead = styled(PlayheadWithoutContext)`
    z-index: 1;
`
